import { Product } from './product.model';

export class Release {
    id: string;
    releaseName: string;
    displayName: string;
    product ?: Product;
    productId ?: string;
    publishDate: string;
}